import { PageContainer, useIfUser } from '@if/mui'
import { useMerchant } from '@src/containers/App/MerchantProvider'
import { useCustomBuydownTimelineQuery } from '@src/data/api/custom-buydown-api/custom-buydown-api'
import { useBorrowerContext } from '@src/hooks/borrower-context-hooks'
import { useTranslation } from 'react-i18next'
import { CustomBuydownSkeleton } from './components/CustomBuydownSkeleton'
import { PlanTimeline } from './components/PlanTimeline'

const useCustomBuydownResources = () => {
  const user = useIfUser()
  return {
    timeline: useCustomBuydownTimelineQuery(user.merchantId),
  }
}

const CustomBuydownPage = () => {
  const { t } = useTranslation()
  const merchant = useMerchant()
  const context = useBorrowerContext()
  return (
    <PageContainer
      usePrimary={useCustomBuydownResources}
      title={t('customBuydown.title', { context })}
      subtitle={t('customBuydown.subtitle', { context })}
      loadingContent={<CustomBuydownSkeleton />}
    >
      {(data) => <PlanTimeline timeline={data.timeline} merchantId={merchant.id} />}
    </PageContainer>
  )
}

export default CustomBuydownPage
